<template name="notice">
  <div>
    <div class="notice-content" v-show="this.hasVisitor">
      <div class="notice">
        <div class="title" v-show="this.chinesContent"><span>{{this.notice.title}}</span></div>
        <div class="title" v-show="this.englishContent"><span>{{this.notice.titleEn}}</span></div>
        <div class="tab">
          <div class="row title">
            <div class="col-6" :class="{'active': item.active!=''}" v-for="(item, index) in tabTitle" @click="contentBtn(index,$event)">
              {{item.content}}
            </div>
          </div>
        </div>
        <div class="chinese-content" v-show="this.chinesContent">
          <article v-html="this.notice.description" @click="contentArticle($event)"></article>
        </div>
        <div class="english-content" v-show="this.englishContent">
          <article v-html="this.notice.descriptionEn" @click="contentArticle($event)"></article>
        </div>
        <div class="btn-agree">
          <button type="button" class="btn btn-gradient" @click="agreeNotice($event)">同意</button>
        </div>
      </div>
    </div>
    <alertModal :modalType="'simple'" :isModalShown="modalTip" :modalTitle="modalTipText" @cancel="closeModal"></alertModal>
    <loading :active.sync="isLoading" :color="'#e42029'"></loading>
  </div>
</template>

<script type="text/javascript">
  import preview from 'vue-photo-preview';
  import 'vue-photo-preview/dist/skin.css';
  import Vue from 'vue';
  import $ from 'jquery';
  import alertModal from '@/components/alertModal.vue';
  import Loading from 'vue-loading-overlay';

  import { getSecurityGuardPostNotice, agreeSecurityGuardPostNotice } from '@/utils/api';
  import { checkNested } from '@/utils/utils';

  import 'vue-loading-overlay/dist/vue-loading.css';
  var options= {
    fullscreenEl:false, //关闭全屏按钮
    escKey: false,
    clickToCloseNonZoomable: true,
  }
  Vue.use(preview,options)
  export default {
    name: 'notice',
    props: {
      alertModal: Boolean,
    },
    components: {
      preview,
      alertModal,
      Loading,
    },
    data() {
      return {
        chinesContent: true,
        englishContent: false,
        tabTitle: [
          { 'content': '中文',
            'active': 'active'
          }, 
          { 'content': 'English',
            'active': ''
          },
        ],
        arrayList: [
          'http://vmapi.ciandt.com.cn:2201/Uploads/Pic_20190428_20190428100040_3140.png',
          'http://vmapi.ciandt.com.cn:2201/Uploads/Pic_20190428_20190428164221_9154.png',
          'http://vmapi.ciandt.com.cn:2201/Uploads/Pic_20190428_20190428164225_4563.png'
        ],
        notice: {},
        modalTip: false,
        modalTipText: '',
        status: false,
        isLoading: false,
        routId: '',
        notice: {},
        checkVisitorList: [],
        hasVisitor: false,
      };
    },
    watch: {
      $route() {
        const routeID = this.$route.params.id;
        this.routId = routeID;
      }
    },
    created() {
      const routeID = this.$route.params.id;
      this.routId = routeID;
      getSecurityGuardPostNotice().then((res) => {
        if (checkNested(res, 'data', 'content', 'model')) {
          if (res.data.content.model) {
            this.notice = res.data.content.model;
          }
          // console.log('获得数据')
          // console.log(this.notice);
        }
      });
    },
    mounted(){
      //异步插入的图片
        setTimeout(() => {
          //vm.img='1.jpg'
          this.$previewRefresh();

          this.setAttr('chinese');
          this.setAttr('english');
          $(".notice-content img").css('width',"100%");
        }, 2000);
      
    },
    methods: {
      setAttr(status) {
        if (status == 'chinese') {
           $('.chinese-content img').attr('preview', '1');
         } else {
           $('.english-content img').attr('preview', '2');
         }
      },
      contentArticle(ev) {
        ev.stopPropagation();
      },
      contentBtn(index,ev) {
        console.log(index)
        ev.stopPropagation();
        const tabTitle = this.tabTitle;
        for (let i = 0; i < tabTitle.length; i += 1) {
          if (i == index) {
            if (index == 0 ){
              this.chinesContent = true;
              this.englishContent = false;
            } else {
              this.chinesContent = false;
              this.englishContent = true;
            }
            tabTitle[i].active = 'active';
          } else {
            tabTitle[i].active = '';
          }
        }
        this.tabTitle = tabTitle;
      },
      agreeNotice(ev) {
       ev.stopPropagation();
        const InvitationId = this.routId;
        const checkVisitorLists = this.checkVisitorList;
        console.log(checkVisitorLists);
        if (checkVisitorLists.length) {
          const data = {
            "invitationId": InvitationId,
            "visitorIdList": checkVisitorLists
          }
          console.log(JSON.stringify(data));
          agreeSecurityGuardPostNotice(data).then((res) => {
            if (checkNested(res, 'data', 'content', 'model')) {
              this.hasVisitor = false;
              this.modalTip = true;
              if (res.data.content.model) {
                this.modalTipText = '阅读成功';
              } else {
                this.modalTipText = res.data.content.message;
              }
            } else {
              this.hasVisitor = false;
              this.modalTip = true;
              this.modalTipText = res.data.message;
            }
          });
        } else {
          this.hasVisitor = false;
          this.modalTip = true;
          this.modalTipText = '至少选择一个访客';
        }
      },
      closeModal() {
        this.$emit('closeNotice', false);
      },
      loadModal(getVisitor,status) {
        this.checkVisitorList = getVisitor;
        this.modalTip = status;
        if (this.checkVisitorList.length) {
          this.hasVisitor = true;
        } else {
          this.hasVisitor = false;
          this.modalTip = true;
          this.modalTipText = '至少选择一个访客';
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .notice-content {
    width: 449px;
    height: 525px;
    background: #fff;
    border-radius: 12px;
    position: absolute;
    left: calc(100%/2 - 449px/2);
    top: calc(100%/2 - 525px/2);
    padding: 30px 43px;
    text-align: center;
    .title {
      width: 363px;
      vertical-align: middle;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      span {
        font-size: 17px;
        color: #4a4a4a;
        font-weight: bold;
      }
    }
    .tab {
      .title {
        border-bottom: 1px solid rgba(101, 101, 101, 0.15);
        margin: 0;
        margin-bottom: 11px;
        div {
          padding-bottom: 3px;
          font-size: 14px;
          color: #4a4a4a;
          cursor: pointer;
        }
        .active {
          border-bottom: 3px solid #e42029;
          color: #e42029; 
        }
      }
    }
    .chinese-content,
    .english-content {
      height: 350px;
      text-align: left;
      overflow-x: hidden;
      overflow-y: auto;
      img {
        width: 100% !important;
      }
    }
    .btn-agree {
      width: 40%;
      margin: 20px auto 30px;
      .btn-gradient {
        width: 100%;
      }
    }
  }
</style>